export const EProcessStatus = {
  PENDING: "PENDENTE",
  PROCESSING: "PROCESSANDO",
  PROCESSED: "PROCESSADO",
  FAILED: "FALHO",
  CANCELLING: "CANCELANDO",
  CANCELED: "CANCELADO",
};

export const ECashbackArchitechStatus = {
  CREATED: "CRIADO",
  PURCHASE_ORDER_CREATED: "ORDEM DE COMPRA CRIADA",
  VALIDATING_NFE: "VALIDANDO NFE",
  NFE_VALIDATED: "NFE VALIDADA",
  APPROVED: "APROVADO",
  REJECTED: "REJEITADO",
  REVERSAL: "ESTORNADO",
};

export const EPlanName = {
  PRO_EXECUTOR: "PRO/EXECUTOR – Ativo",
};

export const ERelationshipStatus = {
  WAITING: "waiting",
  REJECTED: "rejected",
  ACCEPTED: "accepted",
  EXPIRED: "expired",
  CANCELLED: "cancelled",
  FINISHED: "finished",
  EXCLUDED: "excluded",
};

export const ERelationshipStatusPtBR = {
  [ERelationshipStatus.WAITING]: "aguardando",
  [ERelationshipStatus.REJECTED]: "rejeitado",
  [ERelationshipStatus.ACCEPTED]: "aceito",
  [ERelationshipStatus.EXPIRED]: "expirado",
  [ERelationshipStatus.CANCELLED]: "cancelado",
  [ERelationshipStatus.FINISHED]: "finalizado",
  [ERelationshipStatus.EXCLUDED]: "excluído",
};
